import RoutesMap from '../../route_control/RouteControl'
import { TopicList, AddTopic, UpdateTopic, TopicQuestionList, AddTopicQuestion } from '../../pages/master/topic'

export const TopicRouteImport = {
    RoutesMap,
    TopicList,
    AddTopic,
    UpdateTopic,
    TopicQuestionList,
    AddTopicQuestion
}
